// DEPLOY: /var/www/woody.wtf/frontend/src/pages/AnalystProfile.js
// One analyst: summary stats plus every price target with % vs current price.
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';
import Navbar from '../components/Navbar';
import { AnalystTable } from './Analysts';

const S = {
  page:  { minHeight: '100vh', background: 'var(--bg)', display: 'flex', flexDirection: 'column' },
  wrap:  { flex: 1, overflowY: 'auto', padding: '24px 20px' },
  inner: { maxWidth: 1100, margin: '0 auto' },
  card:  { background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 8, padding: '16px 20px', marginBottom: 16, display: 'flex', alignItems: 'baseline', gap: 24, flexWrap: 'wrap' },
  name:  { fontSize: 20, fontWeight: 700, color: 'var(--text)' },
  stat:  { fontSize: 13, color: 'var(--text-secondary)' },
  msg:   { padding: 40, textAlign: 'center', color: 'var(--text-muted)' },
};

const COLS = [
  { key: 'ticker',   label: 'Ticker',   numeric: false },
  { key: 'name',     label: 'Name',     numeric: false },
  { key: 'sector',   label: 'Sector',   numeric: false },
  { key: 'industry', label: 'Industry', numeric: false },
  { key: 'date',   label: 'Date',      numeric: false },
  { key: 'rating', label: 'Rating',    numeric: false },
  { key: 'target', label: 'Target',    numeric: true  },
  { key: 'close',  label: 'Last',      numeric: true  },
  { key: 'pct',    label: '% vs Last', numeric: true  },
];

const pctColor = v => v == null ? 'var(--text-muted)' : v >= 0 ? '#16a34a' : '#dc2626';

export default function AnalystProfile() {
  const { name } = useParams();
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    setLoading(true);
    api.get('/analysts/analyst/' + encodeURIComponent(name))
      .then(r => setData(r.data))
      .catch(e => setError(e.response?.data?.error || 'Failed to load analyst'))
      .finally(() => setLoading(false));
  }, [name]);

  const s = data;

  return (
    <div style={S.page}>
      <Navbar backTo={{ label: 'Analysts', href: '/analysts' }} />
      <div style={S.wrap}>
        <div style={S.inner}>
          {loading ? <div style={S.msg}>Loading...</div>
            : error ? <div style={{ ...S.msg, color: '#dc2626' }}>{error}</div>
            : !data ? null
            : <>
                <div style={S.card}>
                  <span style={S.name}>{s.analyst}</span>
                  {s.firm && <span style={S.stat}>{s.firm}</span>}
                  <span style={S.stat}>{s.count} target{s.count === 1 ? '' : 's'}</span>
                  <span style={S.stat}>{s.tickers} ticker{s.tickers === 1 ? '' : 's'}</span>
                  <span style={{ ...S.stat, fontWeight: 700, color: pctColor(s.avg_pct) }}>
                    Avg {s.avg_pct == null ? '—' : (s.avg_pct > 0 ? '+' : '') + s.avg_pct.toFixed(1) + '%'} vs current
                  </span>
                </div>
                {data.ratings.length === 0
                  ? <div style={S.msg}>No price targets for this analyst</div>
                  : <AnalystTable rows={data.ratings} cols={COLS} defaultSort={{ key: 'date', dir: 'desc' }} />}
              </>}
        </div>
      </div>
    </div>
  );
}
